'use-strict';

import { IScope } from 'angular';
import GLightbox from 'glightbox';
import { FileService } from '../../shared/storage/file.service';

interface GalleryScope extends IScope {
  updateGallery: () => void,
  images: string[];
  panoramic?: string,
  openGalleryAt: (index: number) => void,
  imagesLoaded: () => void,
  mainImages: string[],
  thumbnails: string[],
}

const THUMBNAIL_WIDTH = '400';
const MAIN_WIDTH = '1600';

/* @ngInject */
export default function GalleryController(
  $scope: GalleryScope,
  fileService: FileService,
): void {
  const lightbox: Glightbox = GLightbox({
    loop: true,
  });

  $scope.updateGallery = () => {
    const lightboxImages: GlightboxImage[] = [];
    $scope.mainImages = [];
    $scope.thumbnails = [];

    $scope.images.forEach((image) => {
      const mainImage = fileService.getStaticUrl(image, { width: MAIN_WIDTH });
      const thumbnail = fileService.getStaticUrl(image, { width: THUMBNAIL_WIDTH });

      $scope.mainImages.push(mainImage);
      $scope.thumbnails.push(thumbnail);

      lightboxImages.push({
        href: mainImage,
        type: 'image',
      });
    });

    if ($scope.panoramic) {
      lightboxImages.push({
        href: `https://cdn.pannellum.org/2.5/pannellum.htm#panorama=${fileService.getStaticUrl($scope.panoramic)}&autoLoad=true`,
        type: 'external',
        width: '100vw',
        height: '100vh',
      });
    }

    lightbox.setElements(lightboxImages);
  };

  $scope.openGalleryAt = (index: number) => {
    if (index === -1) {
      lightbox.openAt($scope.mainImages.length);
      return;
    }

    lightbox.openAt(index);
  };

  $scope.imagesLoaded = () => {
    $scope.updateGallery();
  };
}
